import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { VitalsQuestionnaireItem } from './questionnaire'

export const VITALS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [VitalsQuestionnaireItem.MEDICAL_BACKGROUND_VITALS_TEMPERATURE]: QuestionnaireAnswerType.STRING,
  [VitalsQuestionnaireItem.MEDICAL_BACKGROUND_VITALS_PULSE]: QuestionnaireAnswerType.STRING,
  [VitalsQuestionnaireItem.MEDICAL_BACKGROUND_VITALS_RESPIRATIONS]: QuestionnaireAnswerType.STRING,
  [VitalsQuestionnaireItem.MEDICAL_BACKGROUND_VITALS_O2_SATURATION]: QuestionnaireAnswerType.STRING,
  [VitalsQuestionnaireItem.MEDICAL_BACKGROUND_VITALS_BLOOD_PRESSURE]:
    QuestionnaireAnswerType.STRING,
  [VitalsQuestionnaireItem.MEDICAL_BACKGROUND_VITALS_HEIGHT]: QuestionnaireAnswerType.STRING,
  [VitalsQuestionnaireItem.MEDICAL_BACKGROUND_VITALS_BLOOD_SUGAR]: QuestionnaireAnswerType.STRING,
  [VitalsQuestionnaireItem.MEDICAL_BACKGROUND_VITALS_WEIGHT]: QuestionnaireAnswerType.STRING
}
